<template>
  <div class="insurance-and-fund">
    <el-tabs v-model="activeTab" @tab-click="handlerChangeTab">
      <el-tab-pane :label="$xinI18n('社保测算','home-shebaocesuan')" name="insuranceTab">
        <el-form :model="insuranceForm"
                 label-position="top"
                 :rules="rules"
                 size="small"
                 ref="insuranceForm">
          <el-form-item :label="$xinI18n('选择地区','EmployeeSet-AreaPicker-xuanzediqu')+'：'">
            <el-cascader
              v-model="insuranceForm.areaArr"
              :options="cityTree"
              @change="handlerSelectInsuranceCity"></el-cascader>
          </el-form-item>
          <el-form-item :label="$xinI18n('社保户籍类型','home-shebaohujileixing')+'：'" prop="residenceType">
            <el-select v-model="insuranceForm.residenceType" @change="getInitParams">
              <el-option v-for="item in residenceOption" :label="item.label" :value="item.value" :key="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$xinI18n('社保缴纳基数','home-shebaojiaonajishu')+'：'" prop="socialInsuranceBase">
            <el-select v-model="insuranceForm.socialInsuranceBase"
                       @change="changeSocialInsuranceBaseValue">
              <el-option v-for="item in option" :label="item.label" :value="item.value" :key="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="socialInsuranceBaseValue" v-if="insuranceForm.socialInsuranceBase == 0">
            <span slot="label">
              {{ $xinI18n('社保基数','insurance-shebaojishu') }}：
              <el-tooltip effect="dark" :content="$xinI18n('基数范围为{#1}到{#2}','home-jishufanweiweidao',[insuranceBaseMin, insuranceBaseMax])"
                          placement="right">
                <xin-icon xin-type="question"></xin-icon>
              </el-tooltip>
            </span>
            <el-input v-model="insuranceForm.socialInsuranceBaseValue"
                      :placeholder="$xinI18n('请输入社保基数','home-qingshurushebaojishu')" disabled>
            </el-input>
          </el-form-item>
          <el-form-item prop="socialInsuranceBaseValue" v-if="insuranceForm.socialInsuranceBase != 0">
            <span slot="label">
              {{ $xinI18n('社保基数','insurance-shebaojishu') }}：
              <el-tooltip effect="dark" :content="$xinI18n('基数范围为{#1}到{#2}','home-jishufanweiweidao',[insuranceBaseMin, insuranceBaseMax])"
                          placement="right">
                <xin-icon xin-type="question"></xin-icon>
              </el-tooltip>
            </span>
            <el-input v-model="insuranceForm.socialInsuranceBaseValue"
                      :placeholder="$xinI18n('请输入社保基数','home-qingshurushebaojishu')">
            </el-input>
          </el-form-item>
          <el-form-item v-if="isShow" prop="injuryCompanyPercent">
            <span slot="label">
              {{ $xinI18n('工伤保险缴纳比例(%)','home-gsbxjnbl') }}：
              <el-tooltip effect="dark" :content="$xinI18n('比例范围为{#1}到{#2}','home-bilifanweiweidao',[injuryCompanyPercentMin, injuryCompanyPercentMax])"
                          placement="right">
                <xin-icon xin-type="question"></xin-icon>
              </el-tooltip>
            </span>
            <el-input v-model="insuranceForm.injuryCompanyPercent"
                      :placeholder="$xinI18n('请输入工伤保险缴纳比例','home-qsrgsbxjnbl')"></el-input>
          </el-form-item>
          <el-form-item v-else prop="injuryCompanyPercent">
            <span slot="label">
              {{ $xinI18n('工伤保险缴纳比例(%)','home-gsbxjnbl') }}：
              <el-tooltip effect="dark" :content="$xinI18n('比例范围为{#1}到{#2}','home-bilifanweiweidao',[injuryCompanyPercentMin, injuryCompanyPercentMax])"
                          placement="right">
                <xin-icon xin-type="question"></xin-icon>
              </el-tooltip>
            </span>
            <el-input v-model="insuranceForm.injuryCompanyPercent"
                      :placeholder="$xinI18n('请输入工伤保险缴纳比例','home-qsrgsbxjnbl')"></el-input>
          </el-form-item>
        </el-form>
        <div class="result-form" v-if="showInsuranceResult">
          <div class="result-title">
            <h4>{{ $xinI18n('计算结果','home-jisuanjieguo') }}</h4>
            <span>（{{ $xinI18n('由于各地工伤保险略有差异, 计算结果仅供参考','home-yygdgsbxlycyjsjgjgck') }}）</span>
          </div>
          <table>
            <tbody>
            <tr>
              <td>{{ $xinI18n('社保个人缴纳额','home-shebaogerenjiaonae') }}</td>
              <td class="count-value">{{resultForm.personalInsurance}}</td>
              <td>{{ $xinI18n('社保公司缴纳额','home-shebaogongsijiaonae') }}</td>
              <td class="count-value">{{resultForm.companyTotalCost}}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </el-tab-pane>
      <el-tab-pane :label="$xinI18n('公积金测算','home-gongjijincesuan')" name="houseFundTab">
        <el-form :model="houseFundForm"
                 label-position="top"
                 :rules="rules"
                 size="small"
                 ref="houseFundForm">
          <el-form-item :label="$xinI18n('选择地区','EmployeeSet-AreaPicker-xuanzediqu')+'：'">
            <el-cascader
              v-model="houseFundForm.areaArr"
              :options="cityTree"
              @change="handlerSelectHouseFundCity"></el-cascader>
          </el-form-item>
          <el-form-item :label="$xinI18n('公积金缴纳基数','home-gongjijinjiaonajishu')+'：'" prop="isHouseFund">
            <el-select v-model="houseFundForm.isHouseFund" @change="changeHouseFundBaseValue">
              <el-option v-for="item in option" :label="item.label" :value="item.value" :key="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="houseFundBaseValue" v-if="houseFundForm.isHouseFund == 0">
            <span slot="label">
              {{ $xinI18n('公积金基数','insurance-gongjijinjishu') }}：
               <el-tooltip effect="dark" :content="$xinI18n('基数范围为{#1}到{#2}','home-jishufanweiweidao',[houseFundMin, houseFundMax])" placement="right">
                 <xin-icon xin-type="question"></xin-icon>
               </el-tooltip>
            </span>
            <el-input v-model="houseFundForm.houseFundBaseValue"
                      :placeholder="$xinI18n('请输入公积金基数','home-qsrgjjjs')" disabled>
            </el-input>
          </el-form-item>
          <el-form-item prop="houseFundBaseValue" v-if="houseFundForm.isHouseFund != 0">
            <span slot="label">
              {{ $xinI18n('公积金基数','insurance-gongjijinjishu') }}：
               <el-tooltip effect="dark" :content="$xinI18n('基数范围为{#1}到{#2}','home-jishufanweiweidao',[houseFundMin, houseFundMax])" placement="right">
                 <xin-icon xin-type="question"></xin-icon>
               </el-tooltip>
            </span>
            <el-input v-model="houseFundForm.houseFundBaseValue"
                      :placeholder="$xinI18n('请输入公积金基数','home-qsrgjjjs')">
            </el-input>
          </el-form-item>
          <el-form-item label="" prop="houseFundEmployeePercent">
            <span slot="label">
              {{ $xinI18n('公积金个人缴纳比例(%)','home-gjjgrjnbl') }}：
              <el-tooltip effect="dark" placement="right">
                <div slot="content"
                     v-if="currentAreaHouseFundName.indexOf('上海') > -1"
                     v-html="$xinI18n('住房公积金缴纳比例7%，补充住房公积金比例为1%--8%，<br/>如果补充公积金比例为1%--5%不需要交税，超过5%需要交税。','home-zfgjjjnblbczfgjjblwrgbcgj')"></div>
                <div slot="content" v-else-if="currentAreaHouseFundName.indexOf('厦门') > -1">
                  {{ $xinI18n('成立三年以内的企业5.00到12.00，成立三年以上的企业8.00到12.00。', 'home-clsnyndqydclsnysdqyd') }}
                </div>
                <div slot="content" v-else-if="currentAreaHouseFundName.indexOf('成都') > -1">
                  {{ $xinI18n('公积金上限为18242，引进人才公积金缴存上限为30403', 'home-gjjsxwyjrcgjjjcsxw') }}
                </div>
                <div slot="content" v-else>
                  {{ $xinI18n('比例范围为{#1}到{#2}', 'home-bilifanweiweidao', [houseFundEmployeePercentMin, houseFundEmployeePercentMax]) }}
                </div>
                <xin-icon xin-type="question"></xin-icon>
              </el-tooltip>
            </span>
            <el-input v-model="houseFundForm.houseFundEmployeePercent" :placeholder="$xinI18n('数字范围在{#1}~{#2}之间','Common-validate-shuzifanweix-x',[0, 100])"></el-input>
          </el-form-item>
          <el-form-item prop="houseFundCompanyPercent">
            <span slot="label">
              {{ $xinI18n('公积金公司缴纳比例(%)','home-gjjgsjnbl') }}：
              <el-tooltip effect="dark" placement="right">
                <div slot="content"
                     v-if="currentAreaHouseFundName.indexOf('上海') > -1"
                     v-html="$xinI18n('住房公积金缴纳比例7%，补充住房公积金比例为1%--8%，<br/>如果补充公积金比例为1%--5%不需要交税，超过5%需要交税。','home-zfgjjjnblbczfgjjblwrgbcgj')"></div>
                <div slot="content" v-else-if="currentAreaHouseFundName.indexOf('厦门') > -1">
                  {{ $xinI18n('成立三年以内的企业5.00到12.00，成立三年以上的企业8.00到12.00。', 'home-clsnyndqydclsnysdqyd') }}
                </div>
                <div slot="content" v-else-if="currentAreaHouseFundName.indexOf('成都') > -1">
                  {{ $xinI18n('公积金上限为18242，引进人才公积金缴存上限为30403', 'home-gjjsxwyjrcgjjjcsxw') }}
                </div>
                <div slot="content" v-else>
                  {{ $xinI18n('比例范围为{#1}到{#2}', 'home-bilifanweiweidao', [houseFundCompanyPercentMin, houseFundCompanyPercentMax]) }}
                </div>
                <xin-icon xin-type="question"></xin-icon>
              </el-tooltip>
            </span>
            <el-input v-model="houseFundForm.houseFundCompanyPercent" :placeholder="$xinI18n('数字范围在{#1}~{#2}之间','Common-validate-shuzifanweix-x',[0, 100])"></el-input>
          </el-form-item>
        </el-form>
        <div class="result-form" v-if="showHouseFundResult">
          <div class="result-title">
            <h4>{{ $xinI18n('计算结果','home-jisuanjieguo') }}</h4>
          </div>
          <table>
            <tbody>
            <tr>
              <td>{{ $xinI18n('公积金个人缴纳额','home-gjjgrjne') }}</td>
              <td class="count-value">{{resultForm.personalHouseFund}}</td>
              <td>{{ $xinI18n('公积金公司缴纳额','home-gjjgsjne') }}</td>
              <td class="count-value">{{resultForm.companyHouseFund}}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script lang="ts">
  import {Component, Prop, Vue} from 'vue-property-decorator';
  import {CityTreeItem} from '@/module/home/entities/city-tree-item';
  import {HomeApi} from '@/module/home/service/home-api.service';
  import {Validators} from '@xin/xin-ui/src/components/validators/validators';
  import {XinMessage} from '@xin/xin-ui';
  import {XrxsCommonUtils} from '@xin/xin-core';


  @Component({
    name: 'insurance-and-fund'
  })
  export default class InsuranceAndFund extends Vue {
    @Prop({required: true}) public cityTree!: CityTreeItem[];

    public activeTab = 'insuranceTab';
    public currentTab = 'insuranceTab';
    //公积金Form
    public houseFundForm = {
      areaId: 510,
      areaArr: [2, 510],
      houseFundBaseValue: 2148,
      houseFundEmployeePercent: 12,
      houseFundCompanyPercent: 12,
      socialInsuranceBaseValue: 0,
      isSocialInsurance: 0,
      socialInsuranceBase: 0,
      isHouseFund: 0
    };
    //社保Form
    public insuranceForm = {
      areaId: 510,
      areaArr: [2, 510],
      residenceType: 0,
      socialInsuranceBase: 0,
      socialInsuranceBaseValue: 2834,
      injuryCompanyPercent: 0.2,
      isSocialInsurance: 1,
      isHouseFund: 0,
      houseFundBaseValue: 0,
      needSeriousMedical: false,
      seriousMedicalEmployeeFixed: 0,
      seriousMedicalCompanyFixed: 0
    };
    public requiredNumberValidators = [
      {required: true, message: window.$xinI18n('不能为空','Common-bunengweikong'), trigger: 'blur'},
      {
        validator: (rule: any, value: any, cb: any) => {
          Validators.number(rule, value, cb, {message: window.$xinI18n('必须为数字','home-bixuweishuzi')});
        },
        trigger: 'blur'
      }
    ];
    public rules = {
      houseFundBaseValue: this.requiredNumberValidators,
      socialInsuranceBaseValue: this.requiredNumberValidators,
      injuryCompanyPercent: this.requiredNumberValidators,
      houseFundEmployeePercent: this.requiredNumberValidators,
    };
    public residenceOption: { value: number, label: string }[] = [];
    public option = [
      {value: 0, label: window.$xinI18n('最低标准','home-zuidibiaozhun')},
      {value: 2, label: window.$xinI18n('自定义','Common-zidingyi')}
    ];
    /*各种参数上下限start*/
    public insuranceBaseMin = 2834;
    public insuranceBaseMax = 21258;
    public houseFundMin = 2148;
    public houseFundMax = 21258;
    public houseFundEmployeePercentMin = 12;
    public houseFundEmployeePercentMax = 12;
    public houseFundCompanyPercentMin = 12;
    public houseFundCompanyPercentMax = 12;
    public injuryCompanyPercentMin = 0.2;
    public injuryCompanyPercentMax = 3;
    public seriousMedicalEmployeePercent = 0;
    public seriousMedicalCompanyPercent = 0;
    /*各种参数上下限end*/
    public isShow = true;
    public currentAreaHouseFundName = '';
    public showInsuranceResult = false;
    public showHouseFundResult = false;
    public resultForm: any = {};

    public $refs!: {
      insuranceForm: any,
      houseFundForm: any
    };

    async beforeMount() {
      await this.getResidenceType();
      await this.getInitParams();
    }

    private getInitParams(residenceType?: number) {
      const areaId = this.currentTab == 'insuranceTab' ? this.insuranceForm.areaId : this.houseFundForm.areaId;
      return HomeApi.getCalculatorInitParams(areaId, residenceType).then(res => {
          if (res.status) {
            this.houseFundForm.houseFundBaseValue = res.data.houseFundMin;
            this.houseFundForm.houseFundCompanyPercent = res.data.houseFundCompanyPercent;
            this.houseFundForm.houseFundEmployeePercent = res.data.houseFundEmployeePercent;
            this.houseFundMax = res.data.houseFundMax;
            this.houseFundMin = res.data.houseFundMin;
            this.houseFundEmployeePercentMax = res.data.houseFundEmployeePercentMax;
            this.houseFundEmployeePercentMin = res.data.houseFundEmployeePercentMin;
            this.houseFundCompanyPercentMax = res.data.houseFundCompanyPercentMax;
            this.houseFundCompanyPercentMin = res.data.houseFundCompanyPercentMin;
            if (this.currentTab == 'insuranceTab') {
              if (this.insuranceForm.socialInsuranceBase != 2) {
                this.insuranceForm.socialInsuranceBaseValue = res.data.insuranceBaseMin;
              }
              this.isShow = !this.isShow;
              this.insuranceForm.injuryCompanyPercent = res.data.injuryCompanyPercent;
              this.insuranceForm.seriousMedicalEmployeeFixed = res.data.seriousMedicalEmployeeFixed;
              this.insuranceForm.seriousMedicalCompanyFixed = res.data.seriousMedicalCompanyFixed;
              this.insuranceBaseMin = res.data.insuranceBaseMin;
              this.insuranceBaseMax = res.data.insuranceBaseMax;
              this.injuryCompanyPercentMax = res.data.injuryCompanyPercentMax;
              this.injuryCompanyPercentMin = res.data.injuryCompanyPercentMin;
              this.seriousMedicalCompanyPercent = res.data.seriousMedicalCompanyPercent;
              this.seriousMedicalEmployeePercent = res.data.seriousMedicalEmployeePercent;
            }
          }
        }
      );
    }

    private getResidenceType() {
      return HomeApi.getResidenceType(this.insuranceForm.areaId, 1).then(result => {
        if (result.status) {
          this.residenceOption = [];
          for (let [key, value] of Object.entries(result.data)) {
            // @ts-ignore
            this.residenceOption.push({value: Number(key), label: value.toString()});
          }
          this.insuranceForm.residenceType = this.residenceOption[0].value;
        }
      });
    }

    public handlerChangeTab(tab: any) {
      this.currentTab = tab.name;
    }

    /**
     * 社保城市选择
     */
    public handlerSelectInsuranceCity(city: number[]) {
      this.insuranceForm.areaId = city[city.length - 1];
      this.getInitParams();
      this.getResidenceType();
    }

    /**
     * 公积金城市选择
     */
    public handlerSelectHouseFundCity(city: number[]) {
      this.houseFundForm.areaId = city[city.length - 1];
      this.getInitParams();
      this.getResidenceType();
    }

    /**
     * 切换社保缴纳类型，更改社保基数
     * @param val
     */
    public changeSocialInsuranceBaseValue(val: number) {
      if (val == 0) {
        this.insuranceForm.socialInsuranceBaseValue = this.insuranceBaseMin;
      } else {
        this.insuranceForm.socialInsuranceBaseValue = 0;
      }
    }

    /**
     * 切换公积金缴纳类型，更改公积金基数
     * @param val
     */
    changeHouseFundBaseValue(val: number) {
      if (val == 0) {
        this.houseFundForm.houseFundBaseValue = this.houseFundMin;
      } else if (val == 2) {
        this.houseFundForm.houseFundBaseValue = 0;
      }
    }

    /**
     * 计算
     * @param formName
     */
    startToCalculator() {
      if (this.currentTab == 'insuranceTab') {
        let postData = JSON.parse(JSON.stringify(this.insuranceForm));
        postData.needSeriousMedical = Number(this.insuranceForm.needSeriousMedical);
        this.$refs.insuranceForm.validate((valid: boolean) => {
          if (valid) {
            return Promise.resolve(
              HomeApi.employeeCostCount(false, postData).then((res) => {
                if (res.status) {
                  XinMessage.success(res.message);
                  this.showInsuranceResult = true;
                  this.resultForm.personalInsurance = res.data.personalInsurance;
                  this.resultForm.companyTotalCost = res.data.companyTotalCost;
                  this.$forceUpdate();
                } else {
                  XinMessage.error(window.$xinI18n('报错啦~~~','home-baocuola'));
                }
              })
            );
          } else {
            return false;
          }
        });
      } else {
        let postData = XrxsCommonUtils.deepClone(this.houseFundForm);
        postData.isHouseFund = 1;
        this.$refs.houseFundForm.validate((valid: boolean) => {
          if (valid) {
            return Promise.resolve(
              HomeApi.employeeCostCount(false, postData).then((res: any) => {
                if (res.status) {
                  XinMessage.success(res.message);
                  this.showHouseFundResult = true;
                  this.resultForm.personalHouseFund = res.data.personalHouseFund;
                  this.resultForm.companyHouseFund = res.data.companyHouseFund;
                  this.$forceUpdate();
                } else {
                  XinMessage.error(window.$xinI18n('报错啦~~~','home-baocuola'));
                }
              })
            );
          } else {
            return false;
          }
        });
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "insurance-and-fund";
</style>
